import { useFragment } from '@apollo/client';
import cookie from 'js-cookie';

import { useIsClient } from '@utils/common';
import { ProductDetailsInfo , ProductDetailsInfoSkeleton } from '@components/product/ProductDetailsInfo';
import { AgeConfirmationModal } from '@components/AgeConfirmationModal';
import { ADULT_USER_COOKIE } from '@constants';

import {
  ProductDetailsInfoCatalogFragment,
  ProductDetailsInfoCatalogFragmentDoc,
  ProductDetailsInfoFragment,
  ProductDetailsInfoFragmentDoc,
} from './gql/graphql.v3.generated';

type Product = {
  __typename?: 'ProductDetails',
  id: number,
}

type Catalog = {
  __typename?: 'RootCatalog',
  id: string,
}

interface Props {
  className?: string,
  product?: Product,
  catalog?: Catalog | null,
}

export const ProductDetailsInfoContainer: React.FC<Props> = ({
  className,
  product,
  catalog,
}) => {
  const isClient = useIsClient();

  const { data: productData, complete: productDataComplete } = useFragment<ProductDetailsInfoFragment>({
    fragment: ProductDetailsInfoFragmentDoc,
    fragmentName: 'ProductDetailsInfo',
    from: product || null,
  });

  const { data: catalogData, complete: catalogDataComplete } = useFragment<ProductDetailsInfoCatalogFragment>({
    fragment: ProductDetailsInfoCatalogFragmentDoc,
    from: catalog || null,
  });

  if (!productDataComplete || !catalogDataComplete) {
    return (
      <ProductDetailsInfoSkeleton className={className} />
    );
  }

  return (
    <>
      <ProductDetailsInfo
        className={className}
        product={productData}
      />

      <AgeConfirmationModal
        isOpen={isClient && !!catalogData?.isAdultOnly && !cookie.get(ADULT_USER_COOKIE)}
        onCancel={() => {
          window.location.href = '/';
        }}
        onConfirm={() => {
          cookie.set(ADULT_USER_COOKIE, 'true');
          window.location.reload();
        }}
      />
    </>
  );
};
